export default __webpack_public_path__ + "static/media/docker.113bcfc9.png";